import React from 'react';
import { Page, Text } from '../../../components';

export default function AddClient() {
  return (
    <Page
      breadcrumbs={[{ content: 'Clients', href: '/settings/clients' }]}
      title="Add Client"
    >
      <Text>
        {`
          Since adding a client happens infrequently, is simple, and deletion will NOT be supported
          by the front end it is a semi-manual process. To add a client do the following:
        `}
      </Text>
      <ol>
        <li>
          <Text>In the root database add a row to the Client table</Text>
        </li>
        <li>
          <Text>Redeploy the application. (This will trigger the client database setup.)</Text>
        </li>
        <li>
          <Text>Apply any DNS bindings needed for the new subdomain</Text>
        </li>
      </ol>
      <Text>If you do need to delete a client, you can do the following:</Text>
      <ol>
        <li>
          <Text>Remove any DNS bindings needed for the subdomain</Text>
        </li>
        <li>
          <Text>In the root database remove the row from the Client table</Text>
        </li>
        <li>
          <Text>Redeploy the application</Text>
        </li>
        <li>
          <Text>Drop the clients database</Text>
        </li>
      </ol>
    </Page>
  );
}
